import React from 'react';
import logo from '../assets/logo.svg';
import './Footer.css';

const navLinks = [
  { href: '#about',    label: 'About'    },
  { href: '#services', label: 'Services' },
  { href: '#founder',  label: 'Founder'  },
  { href: '#staff',    label: 'Our Team' },
  { href: '#contact',  label: 'Contact'  },
];

const MAPS_LINK = 'https://maps.app.goo.gl/E5xYGoywiRFwwRQR7';

export default function Footer() {
  const scrollTo = (href) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer className="footer">
      <div className="footer-inner">

        {/* Brand */}
        <div className="footer-brand">
          <div className="footer-logo">
            <img src={logo} alt="Akshara Learning Centre" className="footer-logo-img" />
            <div>
              <div className="footer-logo-main">Akshara Learning Centre</div>
              <div className="footer-logo-sub">Empowering Minds, Transforming Lives</div>
            </div>
          </div>
          <p className="footer-desc">
            Personalized educational support for every learner — from remedial teaching and
            NIOS coaching to counselling psychology and behavior therapy.
          </p>
        </div>

        {/* Quick Links */}
        <div className="footer-section">
          <h4 className="footer-heading">Quick Links</h4>
          <ul className="footer-links">
            {navLinks.map((l) => (
              <li key={l.href}>
                <a href={l.href} onClick={(e) => { e.preventDefault(); scrollTo(l.href); }}>
                  {l.label}
                </a>
              </li>
            ))}
          </ul>
        </div>

        {/* Contact */}
        <div className="footer-section">
          <h4 className="footer-heading">Contact</h4>
          <ul className="footer-contact-list">
            <li><span>📧</span> info@aksharalearningcentre.in</li>
            <li><span>📱</span> +91 97500 67070</li>
            <li><span>📱</span> +91 73582 70743</li>
            <li>
              <span>📍</span>
              <a href={MAPS_LINK} target="_blank" rel="noopener noreferrer" className="footer-map-link">
                Plot No:117, Anna Nagar Rd,<br />
                HL Colony, Pammal,<br />
                Chennai – 600075
              </a>
            </li>
            <li><span>🕐</span> Mon–Sat: 10 AM – 6 PM</li>
          </ul>
        </div>

      </div>

      <div className="footer-bottom">
        <p>©2022 Akshara Learning Centre. All rights reserved.</p>
        <p>Founded by Durga Karikalan</p>
      </div>
    </footer>
  );
}
